module.exports = __webpack_public_path__ + "img/jobs_i8_m.b2bd6a78.png";